import { Routes, Route, Navigate } from 'react-router-dom';

import { Page } from 'components/Page';
import { usePermissions } from 'features/permissions';
import { useStore } from 'models/Provider';
import { Api } from 'pages/Profile/api';
import { Details } from 'pages/Profile/details';
import { NotificationSettings } from 'pages/Profile/notifications';
import { Security } from 'pages/Profile/security';

export const Profile = () => {
  const { current } = useStore();
  const { hasRolePermission } = usePermissions();
  return (
    <Page>
      <Routes>
        <Route path="details" element={<Details />} />
        {hasRolePermission('notifications:view') && (
          <Route path="notifications" element={<NotificationSettings />} />
        )}
        <Route path="api" element={<Api />} />
        {!current.info.useForceSso && <Route path="security" element={<Security />} />}
        <Route path="*" element={<Navigate to="/profile/details/" replace />} />
      </Routes>
    </Page>
  );
};
